export class ResourcesState {
  resourcesLoaded = $state(false);
}

export const resourcesState = new ResourcesState();
